import Proxy from '../Proxy';

class StatsRevenueProxy extends Proxy {
  /**
  * The constructor for the ArtistProxy.
  *
  * @param {Object} parameters The query parameters.
  */
  constructor(parameters = {}) {
    super('stats/revenue', parameters);
  }

  list(category) {
    return this.submit('get', `${this.endpoint}/by-period/${category}`);
  }
}

export default StatsRevenueProxy;
